export default __webpack_public_path__ + "static/media/TARJM_Logo_Emblem_Above_Name_With_Tag.668be878.svg";